import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { ClientLogger } from 'bernie-client';
import { MarkPageUsableOptions } from 'bernie-core/dist/store/common/analytics-store';
import { ClientMetadataStore } from 'stores';

export enum CustomPerfMetricsType {
  CACHE_PAGE_USABLE = 'cachePageUsable',
  PAGINATED = 'paginatedMarkValue'
}

const logger = ClientLogger.getLoggerWithIdentifier('utility.customPerfMetrics');
const PAGE_CHANGE = 'Page Change';

const getListingsCustomMetricsTypes = (clientMetadataStore: ClientMetadataStore): CustomPerfMetricsType[] => {
  const customPerfMetricsTypeList: CustomPerfMetricsType[] = [];
  if (clientMetadataStore && clientMetadataStore.isCachedResponse) {
    customPerfMetricsTypeList.push(CustomPerfMetricsType.CACHE_PAGE_USABLE);
  }
  if (clientMetadataStore && clientMetadataStore.isPaginatedResponse) {
    customPerfMetricsTypeList.push(CustomPerfMetricsType.PAGINATED);
  }

  return customPerfMetricsTypeList;
};

function logHighPageUsableValue(pageUsableTime: number, customPerfMetricsType: CustomPerfMetricsType) {
  const pageUsableInSec = Math.round(pageUsableTime / 100) / 10;
  if (pageUsableInSec > 8) {
    logger.logEvent(new SystemEvent(SystemEventLevel.INFO, 'ENVINFO'), customPerfMetricsType + ': ' + pageUsableInSec);
  }
}

function findMark(markName: string): PerformanceEntry {
  if (typeof (performance || {}).getEntriesByType === 'function') {
    const origArr = performance.getEntriesByType('mark');
    const filteredArray = origArr.filter(sRow => sRow.name === markName);

    return filteredArray.length > 0 ? filteredArray[0] : undefined;
  }
}

function getPageUsableTime(markName: string): number {
  const pageUsableTime = (findMark(markName) || {}).startTime - ((findMark(PAGE_CHANGE) || {}).startTime || 0);

  return Math.round(pageUsableTime * 10) / 10;
}

function mark(name: string): void {
  if (typeof (performance || {}).mark === 'function') {
    performance.mark(name);
  }
}

function clearMarks(markName: string): void {
  if (typeof (performance || {}).clearMarks === 'function') {
    performance.clearMarks(markName);
  }
}

export const getCustomMetrics = (customPerfMetricsTypeList: CustomPerfMetricsType[]): MarkPageUsableOptions => {
  try {
    if (!customPerfMetricsTypeList || customPerfMetricsTypeList.length == 0) {
      return null;
    }

    const customPerformanceMetrics: MarkPageUsableOptions = {
      microMessages: [
        {
          schemaName: 'customPerfMetrics',
          messageContent: {
            markName: 'Flights Custom Metrics'
          }
        }
      ]
    };

    customPerfMetricsTypeList.forEach(customPerfMetricsType => {
      const markName = customPerfMetricsType.toString();
      clearMarks(markName);
      mark(markName);
      const value = getPageUsableTime(markName);
      logHighPageUsableValue(value, customPerfMetricsType);
      customPerformanceMetrics.microMessages[0].messageContent[customPerfMetricsType] = value;
    });

    return customPerformanceMetrics;
  } catch (e) {
    logger.logEvent(new SystemEvent(SystemEventLevel.ERROR, 'ENVINFO'), e);
  }
};

export const getListingsCustomMetrics = (clientMetadataStore: ClientMetadataStore): MarkPageUsableOptions => {
  const customPerfMetricsTypeList = getListingsCustomMetricsTypes(clientMetadataStore);
  const options = getCustomMetrics(customPerfMetricsTypeList);

  return options;
};
